export default __webpack_public_path__ + "static/doge_dance-65344905c038f9d02d96d145e17e21a3.gif";